import { render } from "./App.vue?vue&type=template&id=adb8060e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=adb8060e&lang=less"

import exportComponent from "/home/jenkins/.jenkins/workspace/172.16.20.198.leelen-mall-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__